import styles from "./styles.module.scss";
import { Button } from "../button";
import HomeInput from "components/homePage/forms/homeInput";
import classnames from "utilities/classnames";
import { ContactTopic, ContactUsRequest } from "../contactForm/types";
import ErrorHandler from "components/controls/errorHandler";
import { useContactUsForm } from "../contactForm/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons";
import { Loader } from "semantic-ui-react";

export function NotifyMeForm() {
  const initialRequest = new ContactUsRequest({
    topic: ContactTopic.Notify,
    name: "{PLACEHOLDER_NAME}",
    message: "Please notify me when the new Flueid Pro launches.",
  });

  const { contactUsMutation, request, validation, validateForm, handleInputChange, resetForm } =
    useContactUsForm(initialRequest);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      // loading
      if (contactUsMutation.isLoading) return;

      // validate
      const isValid = validateForm();
      if (!isValid) return;

      // send it
      await contactUsMutation.mutateAsync(request);
      resetForm(initialRequest);
      setTimeout(() => contactUsMutation.reset(), 4000);
    } catch (error) {
      ErrorHandler.HandleAxiosError(
        error as any,
        "We're sorry, but we could not submit your request at this time. Please try again later.",
      );
    }
  };

  if (contactUsMutation.isSuccess) {
    return (
      <div className={styles.success_message}>
        <div className={styles.icon}>
          <FontAwesomeIcon icon={faCheckCircle} size="3x" color="green" />
        </div>
        <div className={styles.text}>Thank you! We will notify you when we launch.</div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <form onSubmit={handleSubmit} className={styles.form_mobile}>
        <div className={styles.input_wrapper_mobile}>
          <input
            placeholder="Email Address"
            className={styles.input_mobile}
            value={request.email}
            name="email"
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
          />
          <Button type="submit" primary className={styles.submit_button_mobile} disabled={contactUsMutation.isLoading}>
            {contactUsMutation.isLoading ? (
              <>
                Submitting... <Loader active inline size="tiny" inverted />
              </>
            ) : (
              "Notify Me"
            )}
          </Button>
        </div>
      </form>
      <form onSubmit={handleSubmit} className={styles.form_desktop}>
        <div className={classnames("home_page_contact_form_inputs", styles.input_wrapper_desktop)}>
          <HomeInput
            label="Email Address"
            type="text"
            name="email"
            initialValue={request.email}
            onChange={handleInputChange}
          />
        </div>
        <Button type="submit" primary radius="xl" disabled={contactUsMutation.isLoading}>
          {contactUsMutation.isLoading ? (
            <>
              Submitting... <Loader active inline size="tiny" inverted />
            </>
          ) : (
            "Notify Me"
          )}
        </Button>
      </form>
      {!validation.email?.valid && <div className={styles.error_message}>Please enter valid email</div>}
    </div>
  );
}
